<template>
  <el-header class="header-container">
    <div class="container">
      <!-- 品牌Logo -->
      <div class="logo">
        <img src="@/assets/zxt_log.png" alt="智学堂" class="logo-img" />
        <div class="logo-text">
          <span class="company-name" style="display:none">智学堂</span>
          <span class="domain" style="text-align: center">车载测试技术培训</span>
        </div>
      </div>

      <!-- 桌面端导航菜单 -->
      <el-menu
          :default-active="activeMenu"
          class="desktop-menu"
          mode="horizontal"
          :ellipsis="false"
          @select="handleMenuSelect"
          active-text-color="#12b7f5"
          style="border: none"
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item index="/courses">课程介绍</el-menu-item>
      </el-menu>

      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="toggleMobileMenu" v-if="isMobile">
        <el-icon v-if="!mobileMenuOpen"><Menu /></el-icon>
        <el-icon v-else><X /></el-icon>
      </div>
    </div>



    <!-- 移动端导航菜单 -->
    <el-drawer
        v-model="mobileMenuOpen"
        direction="top"
        :with-header="false"
        :modal="false"
        class="mobile-menu-drawer"
        style="width: 100%"
    >
      <el-menu
          :default-active="activeMenu"
          class="mobile-menu"
          mode="vertical"
          @select="handleMenuSelect"
          style="border: none;"
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item index="/courses">课程介绍</el-menu-item>
      </el-menu>
    </el-drawer>
  </el-header>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Menu, X } from '@element-plus/icons-vue'

// 响应式状态
const isMobile = ref(false)
const mobileMenuOpen = ref(false)
const activeMenu = ref('/')

const route = useRoute()
const router = useRouter()

// 监听窗口大小变化，判断是否为移动设备
const checkScreenSize = () => {
  isMobile.value = window.innerWidth < 768
  // 在移动设备上关闭菜单
  if (!isMobile.value) {
    mobileMenuOpen.value = false
  }
}

// 处理菜单选择
const handleMenuSelect = (index) => {
  router.push(index)
  activeMenu.value = index
  // 移动端选择后关闭菜单
  if (isMobile.value) {
    mobileMenuOpen.value = false
  }
}

// 切换移动端菜单
const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

// 初始化和监听
onMounted(() => {
  checkScreenSize()
  window.addEventListener('resize', checkScreenSize)
  activeMenu.value = route.path
})

// 监听路由变化更新激活菜单
watch(
    () => route.path,
    (newPath) => {
      activeMenu.value = newPath
    }
)
</script>

<style scoped>
.header-container {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  height: 60px;
}

.logo-img {
  height: 44px;
  width: auto;
  margin-right: 10px;
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.company-name {
  font-size: 18px;
  font-weight: bold;
  color: #ff6700;
}

.domain {
  font-size: 12px;
  color: #999;
}

.desktop-menu {
  width: auto;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  display: none;
}

.mobile-menu-drawer {
  height: auto !important;
}

.mobile-menu {
  padding: 20px;
}

/* 响应式样式 */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .company-name {
    font-size: 16px;
  }

  .domain {
    display: none;
  }
}
</style>
